import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../../common/template/content';
import ContentCard from '../../common/template/contentCard';
import ContentCardHeader from '../../common/template/contentCardHeader';
import ContentCardBody from '../../common/template/contentCardBody';
import ContentCardFooter from '../../common/template/contentCardFooter';
import Row from '../../common/layout/row';
import Grid from '../../common/layout/grid';
import Button from '../../common/button/button';
import Form from '../../common/form/form';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndInputNumber from '../../common/form/labelAndInputNumber';
import LabelAndInputMask from '../../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../../common/form/labelAndInputDateTime';
import Select from '../../common/form/select';
import SelectAlteracao from '../../common/form/selectAlteracao';
import LabelAndCheckbox from '../../common/form/labelAndCheckbox';

import LabelAndInputDate from '../../common/form/labelAndInputDate';
import LabelInputSearchLocation from '../../common/form/labelInputSearchLocation';

import {
	setModoTela, initForm
} from './postoNegociacaoActions';

class PostoNegociacaoForm extends Component {

	state = {

	}

	componentWillMount() {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='data_negociacao'
								component={LabelAndInputMask}
								mask= '99/99/9999'
								label='Data' placeholder='Informe o data'
								cols='12 12 4 4'
								readOnly={readOnly} />

							<Select
								name='id_produto'
								label='Produto' placeholder='Informe a produto'
								cols='12 12 12 12'
								readOnly={readOnly}
								options={this.props.listaProduto}
								value={this.props.formularioValues.id_produto}
								onChange={item => this.props.initForm({ ...this.props.formularioValues, id_produto: item })} />

							<Field
								name='prazo'
								component={LabelAndInputNumber}
								label='Prazo (dias)' placeholder='Informe a prazo'
								cols='4 4 4 4'
								readOnly={readOnly}
								casas={0} />

							<Field
								name='preco_anterior'
								component={LabelAndInputNumber}
								label='Preço Anterior' placeholder='Informe a preço'
								cols='4 4 4 4'
								readOnly={'readOnly'}
								casas={2} />

							<Field
								name='preco_atual'
								component={LabelAndInputNumber}
								label='Preço Negociado' placeholder='Informe a preço'
								cols='4 4 4 4'
								readOnly={readOnly}
								casas={2} />
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		)
	}


}

PostoNegociacaoForm = reduxForm({ form: 'postoNegociacaoForm', destroyOnUnmount: false })(PostoNegociacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioLogado: state.auth.usuarioLogado,
	formularioValues: getFormValues('postoNegociacaoForm')(state),
	registro: state.postoNegociacao.registro,
	listaProduto: state.postoNegociacao.listaProduto
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(PostoNegociacaoForm);
